import React from 'react';
import Hero from './components/verification/Hero';
import Main from './components/verification/Main';

const Verification = () => {
    return (
        <div>
            <Hero />
            <Main />
        </div>
    )
}

export default Verification;